module.exports = __webpack_public_path__ + "img/Thank-playing.3bb6ce8f.svg";